import {Pipe, PipeTransform} from "@angular/core";
import {DecimalPipe, getLocaleNumberSymbol, NumberSymbol} from "@angular/common";
import {mergeMap, Observable, of} from "rxjs";
import {Store} from "@ngrx/store";
import {AppState} from "../../store/state/app.state";
import {orderSelector} from "../../store/state/state.selectors";
import {filter, first, map} from "rxjs/operators";
import {ConfigurationProvider} from "../../configuration/configuration.provider";
import {ConfigurationWithClientCountry} from "../../configuration/configuration.model";
import {LocaleService} from "../services/locale.service";
import '@angular/common/locales/global/es'; //TODO walkaround to handle "missing locale es-ES in DecimalPipe"
import '@angular/common/locales/global/es-MX'; //TODO walkaround to handle "missing locale es-MX in DecimalPipe"


@Pipe({
    name: 'price',
    standalone: false
})
export class PricePipe implements PipeTransform {

	constructor(private decimalPipe: DecimalPipe, private store: Store<AppState>, private configProvider: ConfigurationProvider, private localeService: LocaleService) {
	}

	transform(value: number, countryCode: string = null): Observable<string> {
		if (!value) {
			return of('');
		}

		let config$: Observable<ConfigurationWithClientCountry> = countryCode ?
			this.configProvider.getConfigurationFor(countryCode) :
			this.store.select(orderSelector).pipe(filter(order => order.orderUuid != null), first(), mergeMap(order => this.configProvider.getConfigurationFor(order.clientCountry)));

		return config$.pipe(map(config => {
			let pricingConfig = config.clientCountryConfig.order.pricing;
			let formattedValue: string = this.decimalPipe.transform(value, pricingConfig.format);
			if (Number.isInteger(value) && pricingConfig.integersWithoutDecimalPart) {
				let locale: string = !!countryCode ? this.localeService.getLocaleForCountry(countryCode) : this.localeService.clientLocale();
				let splitted = formattedValue.split(getLocaleNumberSymbol(locale, NumberSymbol.Decimal));
				formattedValue = splitted[0];
			}

			return pricingConfig.currency.format.replace('{number}', formattedValue);
		}));
	}
}
